import moment from "moment";

import DoubleDoobleText from "../../icons/doubleDoobleText";

import { useTranslation } from "react-i18next";

import GradientButton from "components/ui/gradientButton/index.jsx";
import { DATE_TIME_FORMAT, PROMOTION_DATE_FORMAT } from "constants/date.constants.js";
import PromotionsPaper from "components/promotionModalNotification/components/promotionsPaper/index.jsx";
import { useEffect, useState } from "react";
import { binaryToFlags } from "utils/binaryCalculations.js";
import { GAME_TYPE, GAME_TYPE_MAPPER } from "constants/game.constants.js";
import PromotionsTag from "components/promotionModalNotification/components/promotionsTag/index.jsx";
import useAppSelector from "hooks/store/useAppSelector.js";
import { selectCurrentPromotionRules, selectIsPromotionRulesLoading } from "store/slices/promotion/selectors.js";
import useAppDispatch from "hooks/store/useAppDispatch.js";
import { PROMOTION_TYPE } from "constants/promotion.constants.js";
import { promotionRulesThunk } from "store/slices/promotion/thunks.js";
import Loader from "components/ui/loader/index.jsx";
import { renderAmount } from "utils/numbersRender.js";
import DoubleDooble from "components/promotionModalNotification/icons/doubleDooble.jsx";
import Promotions from "components/promotionModalNotification/icons/promotions.jsx";
import { mergeClassNames } from "utils/common.js";
import Time from "components/promotionModalNotification/icons/time.jsx";
import { selectSessionGames } from "store/slices/auth/selectors.js";

const PromotionsView = ({
	promotions,
	handleOnActivatePromotions,
	disableBtnActivatePromotions = false,
	isMobile = false
}) => {
	const { t } = useTranslation();
	const [gameTypes, setGameTypes] = useState([]);
	const games = useAppSelector(selectSessionGames);
	const rules = useAppSelector(selectCurrentPromotionRules);
	const promotionRulesLoading = useAppSelector(selectIsPromotionRulesLoading);
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(promotionRulesThunk(PROMOTION_TYPE.DOUBLE_DOOBLE));
	}, []);

	useEffect(() => {
		const allGames = Object.values(GAME_TYPE);
		const allowedGameTypes = binaryToFlags(allGames, promotions.gameType);
		if(games.length === allowedGameTypes.length) {
			setGameTypes(['*']);
		} else {
			setGameTypes(allowedGameTypes);
		}
	}, [promotions?.gameType, games.length]);

	return (
		<div className={mergeClassNames("vs--promotions-modal-view", isMobile ? "mobile" : "")}>
			{/* TODO::: AFTER NEW PROMOTION INTEGRATION INTEGRATION USE SIDEBAR OR NAVBAR  */}
			{/*{isMobile ? (*/}
			{/*	<div className="vs--promotions-modal-view-navbar">*/}
			{/*		<div className="vs--promotions-modal-view-navbar-container">*/}
			{/*			<div className="vs--promotions-modal-view-navbar-container-item active">*/}
			{/*				<span className="vs--promotions-modal-view-navbar-container-item-group">*/}
			{/*					<DoubleDooble />*/}
			{/*					{t("common.doubleDooble")}*/}
			{/*				</span>*/}
			{/*			</div>*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*) : (*/}
			{/*	<div className="vs--promotions-modal-view-sidebar">*/}
			{/*		<div className="vs--promotions-modal-view-sidebar-container">*/}
			{/*			<span className="vs--promotions-modal-view-sidebar-container-header">*/}
			{/*				{t("common.promotions")}*/}
			{/*				<Promotions />*/}
			{/*			</span>*/}
			{/*			<span className="vs--promotions-modal-view-sidebar-container-item active">*/}
			{/*				<DoubleDooble />*/}
			{/*				{t("common.doubleDooble")}*/}
			{/*			</span>*/}
			{/*			/!* TODO:: ADD NEW PROMOTION HERE *!/*/}
			{/*			/!*<span className="vs--promotions-modal-view-sidebar-container-item">*!/*/}
			{/*			/!*	<DoubleDooble />*!/*/}
			{/*			/!*	Bonus Name*!/*/}
			{/*			/!*</span>*!/*/}
			{/*		</div>*/}
			{/*	</div>*/}
			{/*)}*/}
			<div className={mergeClassNames("vs--promotions-modal-view-main", isMobile ? "mobile" : "")}>
				{promotionRulesLoading ? (
					<Loader />
				) : (
					<div className="vs--promotions-modal-view-main-container">
						<div className="vs--promotions-modal-view-main-text">
							<DoubleDoobleText />
						</div>
						<div className="vs--promotions-modal-view-main-block">
						<PromotionsPaper>
							<div className="vs--flex vs--flex-col">
								<span className="vs--promotions-modal-view-main-container-title">{rules?.title}</span>
								<span className="vs--promotions-modal-view-main-container-text">
									<Time />
									{`${moment.utc(promotions.startTime).local().format(PROMOTION_DATE_FORMAT)} - ${moment.utc(promotions.endTime).local().format(PROMOTION_DATE_FORMAT)}`}
								</span>
							</div>
						</PromotionsPaper>

						<PromotionsPaper>
							<div className="vs--flex vs--flex-wrap" style={{ gap: 4 }}>
								{gameTypes.map((gameType) => (
									<PromotionsTag key={gameType}>{GAME_TYPE_MAPPER[gameType] ? t(`common.${GAME_TYPE_MAPPER[gameType]}`) : t(`common.allGames`)}</PromotionsTag>
								))}
							</div>

							<span
								className="vs--promotions-modal-view-main-container-text"
								dangerouslySetInnerHTML={{ __html: rules?.content }}
							/>
						</PromotionsPaper>

						<div className="vs--promotions-modal-view-main-container-group">
							{promotions.singleMin && (
								<PromotionsPaper title="Single Bets">
									<div className="vs--promotions-modal-view-main-container-group-container">
										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name">
												{t("bet.minBet")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value vs--text-ltr"
												title={renderAmount(promotions.singleMin)}
											>
												{renderAmount(promotions.singleMin)}
											</span>
										</div>

										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name center">
												{t("bet.maxBet")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value center vs--text-ltr"
												title={renderAmount(promotions.singleMax)}
											>
												{renderAmount(promotions.singleMax)}
											</span>
										</div>

										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name right">
												{t("bet.maxWin")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value right vs--text-ltr"
												title={renderAmount(promotions.singlePossibleWinMax)}
											>
												{renderAmount(promotions.singlePossibleWinMax)}
											</span>
										</div>
									</div>
								</PromotionsPaper>
							)}

							{promotions.multiMin &&
								<PromotionsPaper title="Multi Bets">
									<div className="vs--promotions-modal-view-main-container-group-container">
										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name">
												{t("bet.minBet")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value vs--text-ltr"
												title={renderAmount(promotions.multiMin)}
											>
												{renderAmount(promotions.multiMin)}
											</span>
										</div>

										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name center">
												{t("bet.maxBet")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value center vs--text-ltr"
												title={renderAmount(promotions.multiMax)}
											>
												{renderAmount(promotions.multiMax)}
											</span>
										</div>

										<div className="vs--promotions-modal-view-main-container-group-container-item">
											<span className="vs--promotions-modal-view-main-container-group-container-item-name right">
												{t("bet.maxWin")}
											</span>

											<span
												className="vs--promotions-modal-view-main-container-group-container-item-value right vs--text-ltr"
												title={renderAmount(promotions.multiPossibleWinMax)}
											>
												{renderAmount(promotions.multiPossibleWinMax)}
											</span>
										</div>
									</div>
								</PromotionsPaper>
							}
						</div>

						<GradientButton
							className="vs--promotions-modal-view-main-container-button"
							type="secondary"
							onClick={handleOnActivatePromotions}
							disabled={disableBtnActivatePromotions}
						>
							{t("common.activatePromotions")}
						</GradientButton>
					</div>
					</div>
				)}
			</div>
		</div>
	);
};
export default PromotionsView;
